import React from 'react';
import { Card, CardActionArea, CardContent, Skeleton, Stack } from '@mui/material';
import LeadCardHeader from './LeadCardHeader';
import LeadAttendanceRow from './LeadAttendanceRow';
import LeadInterest from './LeadInterest';
import LeadContext from './LeadContext';
import LeadExchange from './LeadExchange';
import LeadTargetBusiness from './LeadTargetBusiness';
import LeadOriginInfo from './LeadOriginInfo';
import LeadTrigger from './LeadTrigger';
import useLeadCardPending from '../hooks/useLeadCardPending';
import { getLeadCardBorderColor } from '../utils/leadCardStyles';

// Card completo do lead com o conteúdo de detalhe sempre visível (interesse,
// contexto, origem, gatilho...). Independente de LeadCardCollapsed.js — alterar
// o layout aqui não afeta o card colapsado, embora ambos compartilhem o mesmo
// LeadCardHeader.
const LeadCardNormal = ({ lead, pendingAction }) => {
  const { isPending, fireAction, stop } = useLeadCardPending(pendingAction);

  return (
    <Card
      sx={(theme) => ({
        mb: 2,
        borderRadius: 3,
        borderTop: 4,
        borderTopColor: getLeadCardBorderColor(lead, theme),
        opacity: lead.readOnly ? 0.75 : 1,
      })}
    >
      <LeadCardHeader
        lead={lead}
        pendingAction={pendingAction}
        isPending={isPending}
        fireAction={fireAction}
        stop={stop}
      />

      {/* Área clicável → abre a conversa (chat ao vivo ou prévia). component="div"
          para não aninhar <button>. */}
      <CardActionArea component="div" onClick={lead.onOpenConversation}>
        <CardContent>
          <Stack spacing={2}>
            <LeadAttendanceRow lead={lead} />

            {!lead.hasInsight ? (
              <>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="rounded" height={64} />
                <Skeleton variant="text" width="45%" />
              </>
            ) : (
              <>
                <LeadInterest interest={lead.interest} />
                {/* Emoji de sentimento desativado provisoriamente — para reativar,
                    voltar a passar sentimentEmoji={lead.sentimentEmoji}. */}
                <LeadContext context={lead.context} />
              </>
            )}

            <LeadOriginInfo
              campaignId={lead.campaignId}
              campaignTitle={lead.campaignTitle}
              campaignExternalId={lead.campaignExternalId}
              originName={lead.originName}
            />

            {lead.hasInsight && (
              <>
                <LeadTargetBusiness targetBusiness={lead.targetBusiness} />
                <LeadExchange exchange={lead.exchange} />
                <LeadTrigger trigger={lead.trigger} />
              </>
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default LeadCardNormal;
